module.exports = __webpack_public_path__ + "static/img-main-sp-bfc594f4fd8f5e5fd749fba152f45c03.jpg";